export enum App {
  loading,
  loaded,
  offline,
}
